import type { EmptyStateActionVariant, IEmptyStateAction } from './EmptyStateAction';

/** Вид действия без своего `variant`: первое — главное. */
export const emptyStateActionVariant = (action: IEmptyStateAction, index: number): EmptyStateActionVariant =>
    action.variant ?? (index === 0 ? 'primary' : 'outline');
